import { Container } from "@mui/material";
import React from "react";
import MultiStepForm from "../components/bookNow/index";

function BookNow() {
  return (
    <>
      <Container maxWidth="xl">
        <MultiStepForm />
      </Container>
    </>
  );
}

export default BookNow;
